module.exports = __webpack_public_path__ + "static/media/Netflix.140a1865.jpg";